import {autoImplement} from '@/util';


export interface ApiShelf {
  Niederlassung: number;
  Lagerhalle: number;
  Lagerfach: number;
  Bezeichnung: string;
  Aktiv: 'J' | 'N';
}

export interface ShelfFilters {
  Niederlassung?: number;
}

export default class Shelf extends autoImplement<ApiShelf>() {
  static fromApi(apiShelf: ApiShelf): Shelf {
    return new Shelf(apiShelf);
  }
}
